import React, { Component } from 'react';
import Transition from 'react-transition-group/Transition';




class WorkDetail extends Component {
	constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);           
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
        	in: false,
        	active:false,
        	activeIndex: null
        }
    }

	componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    	if(this.props.details ) {
	    	this.enterState();	
    	}

    }

    

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }




    setWrapperRef(node) {
	    this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.closeDetail();
        }
    }

	toggleClass=(index) => {
        const currentState = this.state.active;
        // console.log(currentState)
        this.setState({ 
        	activeIndex: index
         });
    };

	enterState = () => {
	  this.setState({ in: true });
	}
	exitState = () => {
	  this.setState({ in: false });
	}


	renderDetails () {

			let {showWorkDetails, details, navContent} = this.props;
			// console.log(showWorkDetails, details, navContent)
			if(details && showWorkDetails ){
				let { bg_img, url, title, description } = details[0];
				return(
					<div style={{width: "100%", paddingTop: "20px", paddingBottom: "10px"}}>
						<div 
							className="WorkDetail__Container--BG"
							style={{
								backgroundImage: "url("+bg_img+")"
							}}
						>
						</div>
						<div className="WorkDetail__Container--Copy">
							<h2>Project: <a href={url} target="_blank">{title}</a></h2>
							<p>{description}</p>
						</div>
					</div>
				)
			} 

			if(details && !showWorkDetails) {
				// console.log(details)
				let {locationContent} = details
				return(
					<div className="WorkDetail__Container--Copy">
						<p>{locationContent.copy}</p>
					</div>
				)
			}

			// if(navContent.landingContent && !showWorkDetails){
			// 	let {navTitle, landingContent } = navContent;
			// 	let { active, activeIndex } = this.state;

			// 	if(navTitle === "Education"){
			// 		return(
			// 			<div className="WorkDetail__Container--Education" style={{width: "100%"}}>
			// 				<div className={"Kentucky " + (activeIndex===0 ? 'active':null)}
			// 					onClick={()=> {
			// 						this.toggleClass(0)
			// 						this.props.handleJumpTo(landingContent.kentucky.coordinates, landingContent.kentucky.zoom)
			// 					}} 
			// 					style= {{backgroundImage: "url("+require('../assets/img/seebluebg-1.png')+")"}}>
			// 				</div>
			// 				<div className={"CreativeCircus "+ (activeIndex===1 ? 'active':null)}
			// 				onClick={()=> {
			// 					this.toggleClass(1)
			// 					this.props.handleJumpTo(landingContent.circus.coordinates, landingContent.circus.zoom)
			// 				}} 
			// 				 style= {{backgroundImage: "url("+require('../assets/img/circus.png')+")"}}>
			// 				</div>
			// 			</div>
			// 		)
			// 	} else {
			// 		<div></div>
			// 	}
				
			// }


			
	}


	render() {

		const defaultStyle = {
		  opacity: 0,
		  width: "0px"
		}
		
		let transitionStyles

		if(this.props.isMobile) {
			transitionStyles = {
			  entering: { opacity: 0, width: "0" },
			  entered: { opacity: 1, width:"100%" }
			};
		}else{
			transitionStyles = {
			  entering: { opacity: 0, width: "0" },
			  entered: { opacity: 1, width:"70%" }
			};
		}


		const defaultWordStyle = {
			opacity: 0,
			transition: `all 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275)`
		}

		const wordTransitionStyles = {
		  entering: { opacity: 0 },
		  entered: { opacity: 1}
		};

		return(
			<Transition
			in={this.state.in}
			timeout={300}>
				{
					(state) =>{
						// let bradLogo = require('../assets/img/brad-logo.png');
						return(
							<div className="WorkDetail" 
							ref={this.setWrapperRef} 
							style={{
								...defaultStyle,
								...transitionStyles[state]
							}}>

									<Transition
									in={this.state.in}
									timeout={900}>
										{
											(state) =>{
													return(

														<div 
															className="WorkDetail__Container"
															style={{
																...defaultWordStyle,
																...wordTransitionStyles[state]
															}}>
																{this.renderDetails()}
														</div>
													)
												
											}
										}
									</Transition>
								
							</div>
						)}
				}
			</Transition>
		)
	}

}

export default WorkDetail;


// WEBPACK FOOTER //
// ./src/components/WorkDetail.js